// extracted by mini-css-extract-plugin
export default {"link":"style_link__aS7q9","active":"style_active__p0gnP"};